module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/nagoya_point2_5-fca40ab6c11cfe3d5f899749fada5ff6.jpg";